module.exports = __webpack_public_path__ + "static/media/bt_top_mofftre_normal.51020682.png";